/**
 * @generated SignedSource<<a9a4594796ead72e232838fca4614997>>
 * @relayHash 0c6b8b98d8d0d7ed7883088733e72d20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d15800213457a7a87b727610562460e90dc37726520c34ca32a874f96272a4dd

import type { ConcreteRequest } from 'relay-runtime';
export type StudioBuildState = "FAILED" | "IN_PROGRESS" | "SUCCESS" | "WAITING" | "%future added value";
export type StudioBuildType = "AUTOMATION_RULE" | "ECOSYSTEM_APP" | "ROVO_AGENT" | "%future added value";
export type StudioPlanState = "COMPLETED" | "DISABLED" | "DRAFT" | "FAILED" | "IN_PROGRESS" | "%future added value";
export type studioTriggerSolutionBuildSolutionPlanQuery$variables = {
  shouldIncludeAri: boolean;
  skip: boolean;
  solutionId: string;
  solutionVersion: number;
  workspaceAri: string;
};
export type studioTriggerSolutionBuildSolutionPlanQuery$data = {
  readonly studio_solutionPlan?: {
    readonly builds: {
      readonly sequence: ReadonlyArray<{
        readonly associatedObjectAri?: string | null;
        readonly buildId: string | null;
        readonly dependencies: ReadonlyArray<number | null> | null;
        readonly name: string | null;
        readonly number: number | null;
        readonly overview: string | null;
        readonly state: StudioBuildState | null;
        readonly type: StudioBuildType | null;
      } | null> | null;
    } | null;
    readonly conversationId: string | null;
    readonly currentBuildNumber: number | null;
    readonly name: string | null;
    readonly solutionId: string | null;
    readonly solutionVersion: number | null;
    readonly spaceId: string | null;
    readonly state: StudioPlanState | null;
  } | null;
};
export type studioTriggerSolutionBuildSolutionPlanQuery = {
  response: studioTriggerSolutionBuildSolutionPlanQuery$data;
  variables: studioTriggerSolutionBuildSolutionPlanQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "solutionId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "solutionVersion"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "state"
},
v7 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "solutionId",
            "variableName": "solutionId"
          },
          {
            "kind": "Variable",
            "name": "solutionVersion",
            "variableName": "solutionVersion"
          },
          {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceAri"
          }
        ],
        "concreteType": "StudioSolutionPlan",
        "kind": "LinkedField",
        "name": "studio_solutionPlan",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "spaceId"
          },
          {
            "kind": "ScalarField",
            "name": "solutionVersion"
          },
          {
            "kind": "ScalarField",
            "name": "currentBuildNumber"
          },
          {
            "kind": "ScalarField",
            "name": "conversationId"
          },
          {
            "kind": "ScalarField",
            "name": "solutionId"
          },
          (v6/*: any*/),
          {
            "concreteType": "StudioBuilds",
            "kind": "LinkedField",
            "name": "builds",
            "plural": false,
            "selections": [
              {
                "concreteType": "StudioBuild",
                "kind": "LinkedField",
                "name": "sequence",
                "plural": true,
                "selections": [
                  {
                    "condition": "shouldIncludeAri",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "associatedObjectAri"
                      }
                    ]
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "number"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "dependencies"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "buildId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "overview"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "studioTriggerSolutionBuildSolutionPlanQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "studioTriggerSolutionBuildSolutionPlanQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "id": "d15800213457a7a87b727610562460e90dc37726520c34ca32a874f96272a4dd",
    "metadata": {},
    "name": "studioTriggerSolutionBuildSolutionPlanQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "34d4a09e864f38362051dbaedb75dca9";

export default node;
